<template>
  <el-container>
    <el-aside class="aside">
        <h1>{{$t('kportal.title')}}</h1>
          <!-- <el-menu
            :default-active="currentMenu"
            class="el-menu-vertical"
            background-color="#F8F8F8"
            text-color="#707070"
            unique-opened
            active-text-color="#ED6D00"
            @select="selectMenu">
            <el-menu-item index="/news/groupNews" style="padding-left:0;">{{$t('news.function[0].name')}}</el-menu-item>
            <div class="line"></div>
            <el-menu-item index="/news/industryDynamics" style="padding-left:0;">{{$t('news.function[1].name')}}</el-menu-item>
            <div class="line"></div>
        </el-menu> -->
    </el-aside>
    <el-main>
        <KportalIndex></KportalIndex>
    </el-main>
  </el-container>
</template>
<script>
import KportalIndex from '@/components/kportalIndex/kportalIndex'
export default({
    components: {KportalIndex},
    data() {
        return{}
    },
})
</script>

<style src="../../css/common.css"></style>
<style src="../../css/style.css"></style>
<style scoped>
    /deep/ .el-menu{
        border-right:0px;
        font-size: 20px;
    }
    /deep/ .el-submenu__title{
        height: 51px;
        line-height: 51px;
        font-size: 20px;
        padding-left: 0!important;
    }
    /deep/ .el-submenu.is-active .el-submenu__title {
        border-bottom-color: transparent
    }
    /deep/ .el-menu-item {
        height: 51px;
        line-height: 51px;
        font-size: 20px;
    }
    .line{
        border-top: 1px solid rgba(112, 112, 112, 0.25);;
    }
</style>


// WEBPACK FOOTER //
// src/pages/kportal/kportal.vue